import { sendAPIRequest } from "shared/utils/requests";

import React, { Component } from "react";
import _ from "lodash";
import { Radio, RadioGroup } from "@blueprintjs/core";
import classNames from "classnames";

class QuizQuestion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedIndex: -1,
    };

  }

  render() {
    const {
      question,
      answers,
      setAnswerIndex,
      wrongIndex,
      index,
    } = this.props;

    const {
      selectedIndex,
    } = this.state;

    return (
      <div className="onboarding-privacy-quiz-item">
        <div className="onboarding-privacy-quiz-item-question">
          <div className="onboarding-privacy-quiz-item-question-number">{index}</div>
          <div className="onboarding-privacy-quiz-item-question-text">{question}</div>
        </div>
        <RadioGroup
          selectedValue={selectedIndex}
          onChange={(e) => {
            this.setState({ selectedIndex: e.target.value });
            setAnswerIndex(parseInt(e.target.value));
          }}
        >
          {answers.map((answer, answerIndex) => {
            const wrong = wrongIndex == answerIndex;
            const radioClasses = classNames({
              'onboarding-privacy-quiz-item-answer': true,
              'onboarding-privacy-quiz-item-answer-wrong': wrong,
            });
            return (
              <Radio className={radioClasses} key={answerIndex}
                label={answer}
                value={`${answerIndex}`}
              />
            );
          })}
        </RadioGroup>
      </div>
    );
  }

}

export default QuizQuestion;
